import { toast } from "react-toastify";
import { t } from "i18next";
import { historyRepository } from "../../../providers/repositories/historyRepository";
import Logger from "../../../utils/Logger";
import type { HistoryVersionDetail } from "../entities/HistoryVersion";

/// Récupère le snapshot complet d'une version, pour la comparaison côte à côte.
export const getHistoryVersionUseCase = {
  async exec(versionId: string): Promise<HistoryVersionDetail | null> {
    try {
      return await historyRepository.getVersion(versionId);
    } catch (error) {
      toast.error(t("history.loadError"));
      Logger.error("getHistoryVersionUseCase", error);
    }
    return null;
  },
};
